export const updateCalendar = (date) => {
    return (dispatch, getState) => {
        dispatch({ type: 'CALENDAR_UPDATE', date })
    }
}
